import {NgClass} from '@angular/common';
import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {KENDO_BUTTONS} from '@progress/kendo-angular-buttons';
import {DatePickerComponent, KENDO_DATEINPUTS} from '@progress/kendo-angular-dateinputs';
import {BaseFilterCellComponent, FilterService, FilterCellOperatorsComponent, ColumnComponent} from '@progress/kendo-angular-grid';
import {CompositeFilterDescriptor} from '@progress/kendo-data-query';
import {filterClearIcon, SVGIcon} from '@progress/kendo-svg-icons';


//Composant filtre rapide date
@Component (
{
  selector: 'val-date-filtre-rapide',
  imports: 
  [
    NgClass,
    KENDO_BUTTONS,
    KENDO_DATEINPUTS,
    FilterCellOperatorsComponent
  ],
  templateUrl: './date-filtre-rapide.component.html',
  styleUrl: './date-filtre-rapide.component.scss',
})
export class DateFiltreRapideComponent extends BaseFilterCellComponent implements AfterViewInit
{
  //Création
  //  Paramètres
  //    filterService : Service filtre
  constructor (filterService: FilterService) 
  {
    super (filterService);

    this.boutonEffacerVisible = false;
    this.boutonEffacerIcone = filterClearIcon;
    this.valeur = null;
    this.operateur = "eq";
  }

  //Editeur
  @ViewChild ("editeurDate")
  public editeurDate!: DatePickerComponent;

  //Indique si le bouton effacer est visible
  public boutonEffacerVisible: boolean;

  //Icone du bouton effacer
  public boutonEffacerIcone: SVGIcon;

  //Description des filtres
  @Input ()
  public override filter!: CompositeFilterDescriptor;

  //Nom du champ
  @Input ()
  public nomChamp!: string;

  @Input ()
  public column!: ColumnComponent;

  //Valeur
  public valeur: Date | null;

  //Opérateur
  public operateur: string;

  //Après l’initialisation du contenu
  public ngAfterViewInit(): void 
  {
    this.editeurDate.dateInput.dateInput.nativeElement.onblur = this.ChangerValeurFiltre.bind (this);
  }

  //Retourne la valeur sélectionnée
  public get selectedValue () : any 
  {
    const filter = this.filterByField (this.nomChamp);

    return filter ? filter.value : null;
  }

  //Après l’initialisation du contenu
  public override ngAfterContentInit() : void 
  {
    const filter = this.filterByField (this.nomChamp);

    if (filter)
    {
      this.valeur = filter.value;
      this.operateur = filter.operator as string;
      this.boutonEffacerVisible = true;
    }
  }

  //Change la valeur du filtre
  public ChangerValeurFiltre () : void 
  {
    if (this.valeur === null)
      this.applyFilter (this.removeFilter (this.nomChamp));
    else
    {
      this.applyFilter (this.updateFilter (
                      {
                        field: this.nomChamp,
                        operator: this.operateur,
                        value: this.valeur
                      })
      );
    }

    if (this.valeur !== null)
      this.boutonEffacerVisible = true;
  }

  //Change l’opérateur
  public ChangerOperateur () : void 
  {
    setTimeout (() => {this.ChangerValeurFiltre ();}, 50);    
  }

  //Traite la fermeture de la popup
  public TraiterFermeturePopUp () : void 
  {
    setTimeout (() => {this.ChangerValeurFiltre ();}, 50);
  }

  //Efface l’éditeur
  public Effacer () : void 
  {
    this.valeur = null;

    this.applyFilter (this.removeFilter (this.nomChamp));

    this.boutonEffacerVisible = false;
  }
}
